import type { DatabaseInfo } from '../../services/database-discovery';

/**
 * A mailbox's folder tables (Inbox, Sent, Drafts, Archive, Trash) never hold
 * rows: every mail is a row of the mailbox's "Messages" table. As an
 * automation source they would start nothing, so the source choice leaves
 * them out.
 */
export function isMailFolderTable(
  database: Pick<DatabaseInfo, 'managedBy' | 'tableRole'>
): boolean {
  return (
    database.managedBy === 'workspace-mail' &&
    database.tableRole === 'folder_view'
  );
}
